import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-caret-up', 'IconCircleCaretUp', [
  ['path', { d: 'M12 9l4 4h-8z', key: 'svg-0' }],
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-1' }],
]);
